<template>
  <div class="web-header">
    <div class="web-header_title" title="包头NQI一站式服务平台" @click="goIndex()">
      <img src="../images/head_title.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      input1:''
    }
  },
  methods: {
    goIndex() {
      console.log("跳转首页")
      this.$router.push({
        path:'/'
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.web-header{
  position: relative;
  width: 100%;
  height: 85px;
  background: url(../images/head_bg.png) no-repeat center top;
  background-size: auto 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.web-header_title{
  height: 100%;
  cursor: pointer;
}
.web-header_title img{
  width: auto;
  height: 100%;
}
.web-header-tools{
  position: absolute;
  width: 30%;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.web-header-tools .el-input{
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue